import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import TurningPage from "@/pages/TurningPage";
import MillingPage from "@/pages/MillingPage";
import CADImportPage from "@/pages/CADImportPage";
import SavedProgramsPage from "@/pages/SavedProgramsPage";
import SettingsPage from "@/pages/SettingsPage";
import FileConverterPage from "@/pages/FileConverterPage";
import FeedsSpeedsPage from "@/pages/FeedsSpeedsPage";
import CycleGeneratorPage from "@/pages/CycleGeneratorPage";
import JobPlansPage from "@/pages/JobPlansPage";
import VPulleyPage from "@/pages/VPulleyPage";
import SoftJawsPage from "@/pages/SoftJawsPage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/turning" element={<TurningPage />} />
            <Route path="/milling" element={<MillingPage />} />
            <Route path="/cad-import" element={<CADImportPage />} />
            <Route path="/saved" element={<SavedProgramsPage />} />
            <Route path="/converter" element={<FileConverterPage />} />
            <Route path="/feeds-speeds" element={<FeedsSpeedsPage />} />
            <Route path="/cycle-generator" element={<CycleGeneratorPage />} />
            <Route path="/job-plans" element={<JobPlansPage />} />
            <Route path="/v-pulley" element={<VPulleyPage />} />
            <Route path="/soft-jaws" element={<SoftJawsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
